import { t } from '@transifex/native'

const translationMappings = {
  deliveries: t('Deliveries'),
  carrierDoorAccess: t('Carrier door access'),
  remoteCarrierDoorAccess: t('Remote access (carrier door)'),
  rental: t('Rental'),
  remoteAccess: t('Remote access'),
  storageModifyInventory: t('Smart Storage (modify inventory)'),
  storageCreateOrder: t('Smart Storage (withdrawals)'),
  carrierDoorOpen: t('Drivers'),
  storageOrder: t('Withdrawal'),
  QuantityChange: t('Balance updated'),
  storageSupplierOrder: t('Automatic order'),
  NewItem: t('Item added'),
  contactPerson: t('Administrator'),
}

export const countryPhoneFormatMapping = {
  SE: 'ex. 0701234567',
  NO: 'eks. 41234567',
  FI: 'ex. 401234567',
  GB: 'e.g. 07700900418',
  DK: 'eks. 12345678',
  PL: 'np. 512345678',
  DE: 'z.B. 15123456789',
  FR: 'ex. 612345678',
  ES: 'ej. 612345678',
  PT: 'ex. 912345678',
  LT: 'pvz. 61234567',
}

const translations = [
  t('Wrong username or password'),
  t('Article number'),
  t('Article name'),
  t('Quantity'),
  t('Mark'),
  t('Previous quantity'),
  t('New quantity'),
  t('Previous max quantity'),
  t('New max quantity'),
  t('Previous order point'),
  t('New order point'),
  t('Preferred Delivery Days'),
  t('Previous Preferred Delivery Days'),
]

console.log(translations)

export default translationMappings
